module.exports = __webpack_public_path__ + "img/ChangePassword.e8737b41.png";